import { Link } from "react-router-dom";
import "./navbar.scss";
import { Dropdown, Modal, Offcanvas } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useWeb3React } from "@web3-react/core";
import useAuth from "../../../hooks/useAuth";
import useSignature from "../../../hooks/userSign";
import { API_URL } from "../../../utils/ApiUrl";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from '../../../hooks/loader';
import { toast } from "react-toastify";
import Notifications from "./Notifications";
import ConditionalLink from "../../../helper/Components/ConditionalLink";
import { setupNetwork } from "../../../utils/wallet";
import { useLocation } from "react-router-dom";
import CustomToast from '../../../components/CustomToast';


const Navbar = ({ profile }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const [projectBannerImg, setProjectBannerImg] = useState(null)
  const navigate = useNavigate()
  const accessToken = useNavigate()
  const { userSign } = useSignature();
  const { login, logout } = useAuth();
  const { account, chainId } = useWeb3React();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [currAccount, setCurrAccount] = useState()
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const [trust, setTurst] = useState(false)
  const [userData, setUserData] = useState()
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const [notificationBool, setNotificationBool] = useState(false)
  const [wallet, setWallet] = useState(false);
  const [socket, setSocket] = useState(null);
  const [status, setStatus] = useState('cxv');
  const [notifications, setNotifications] = useState([]);
  const [loader, setLoader] = useState(false);
  // console.log(status, 'statusstatus');

  const trustWallet = async () => {

    try {
      if (account) {
        await logout("walletconnect");
        localStorage.clear();
      } else {
        login("walletconnect");
        handleClose()
        localStorage.setItem('connectorId', 'walletconnect');
        localStorage.setItem("flag", "true");
        setTurst(true)
      }
    } catch (err) {
      // console.log("eerr", err);
    }

  };


  const connectMetaMask1 = async () => {
    setLoader(true);
    if (account) {
      const connectorId = window.localStorage.getItem("connectorId")
      await logout(connectorId);
      localStorage.removeItem("connectorId");
      localStorage.removeItem("flag");
    } else {
      // typeof window.ethereum === 'undefined'
      if (typeof window.ethereum === 'undefined') {
        // Show a toast error if MetaMask is not installed on desktop
        // toast.info('Please install MetaMask to connect your wallet.');
        CustomToast.show('warning', 'Warning!', 'Please install MetaMask to connect your wallet.')

        return
      }
      login("injected");
      localStorage.setItem("connectorId", "injected");
      localStorage.setItem("flag", "true");
      handleClose();
      handleShow2();

      try {
        setLoader(true);
        let res = await setupNetwork();
        console.log("network....", res);

        if (res) {
          console.log("network.... if 1");
          login("injected");
          localStorage.setItem("connectorId", "injected");
          localStorage.setItem("flag", "true");
          setLoader(false);
          handleClose();
          handleShow2();
          console.log("network.... end");
        }
      } catch (error) {
        console.log("network.... else");
        setLoader(false);
        // console.log(error)
        // localStorage.clear()
        localStorage.removeItem("TokendollorVal");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("connectorId");
        localStorage.removeItem("flag");
        // localStorage.removeItem("hygtCommission");
        // localStorage.removeItem("refreshToken");
        // localStorage.removeItem("user")
      }
    }
  };


  const clearData = async (noRoute) => {
    const connectorId = window.localStorage.getItem("connectorId")
    await logout(connectorId);
    localStorage.removeItem("connectorId");
    localStorage.removeItem("flag");
    localStorage?.removeItem("accessToken");
    localStorage?.removeItem("sign");
    localStorage?.removeItem("userId");
    localStorage?.removeItem("refreshToken");
    localStorage?.removeItem("addrSign");;
    localStorage.removeItem('userId')
    // localStorage.removeItem('socketConnected')
    disconnect()
    setWallet(null)
    if (noRoute) {

    } else {
      setTimeout(() => {
        navigate('/')
      }, "1000");
    }



  };

  const signInUser = async () => {
    let tok = localStorage.getItem("accessToken");
    let addrSign = localStorage.getItem("addrSign");
    if (tok && addrSign === account) {
      // console.log('asdsasaddsad');
      setWallet(account)
    } else {
      try {
        setLoader(true)
        let v = await userSign();
        if (v) {
          handleClose2()
          localStorage.setItem('sign', v)
          setWallet(account)
          var config = {
            method: "post",
            url: `${API_URL}auth/users/signup-signin`,
            data: {
              walletAddress: account.toLowerCase(),
              sign: v,
              "rememberMe": false
            },
          }
          await axios(config)
            .then(function (res) {
              const resData = res?.data?.data;
              // setAccessToken(resData?.accessToken)
              // console.log(resData, "resData sigin");
              localStorage?.setItem("accessToken", resData?.accessToken);
              localStorage?.setItem("userId", resData?.userId);
              localStorage?.setItem("refreshToken", resData?.refreshToken);
              localStorage?.setItem("addrSign", account);;

              setUserData(resData)
              getProfile()
              // setTimeout(() => {
              //   window.location.reload()
              // }, 2000);
              // window.location.reload()
              setLoader(false)
              setTimeout(() => {
                window.location.reload()
              }, 1000);
            })
            .catch(function (err) {
              setLoader(false);
              CustomToast.show('error', 'Error!', err ? err : 'Something failed');
              throw err;
            });

        };

      } catch (err) {
        // console.log(err, 'user sign error');
        setLoader(false)
        // clearData()
      }
    }
  }

  // useEffect(() => {
  //   // Update the timer every second
  //   if (chainId != 42161) {
  //     setupNetwork(42161);
  //   }
  // }, [chainId]);

  useEffect(() => {
    if (account) {
      if (trust) {
        handleShow2()
      }
    }
  }, [account, trust]);

  useEffect(() => {
    let tok = localStorage.getItem("accessToken");
    let addrSign = localStorage.getItem("addrSign");
    if (account) {
      if (tok && addrSign) {
        signInUser()
      }
    }
  }, [account])

  const refreshTokeen = async () => {
    let retoken = localStorage.getItem("refreshToken");
    var config = {
      method: "post",
      url: `${API_URL}auth/users/refresh-token`,
      data: {
        refreshToken: retoken,
      },
    };

    await axios(config)
      .then(function (res) {
        const resData = res?.data?.data;
        localStorage?.setItem("accessToken", resData?.accessToken);
        localStorage?.setItem("refreshToken", resData?.refreshToken);
        getProfile()
        // setLoader(false)
      })
      .catch(function (err) {

        throw err;
      });
  };



  const getProfile = async () => {
    let accessToken = localStorage.getItem('accessToken')
    var config = {
      method: "get",
      url: `${API_URL}users`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`  // Include the access token here
      },

    }
    try {
      let response = await axios(config)

      if (response) {
        console.log(response, "response in profile.....");
        localStorage?.setItem("isEmailVerified", response?.data?.data?.isEmailVerified)
        localStorage?.setItem("userId", response?.data?.data?.id);
        localStorage?.setItem("userName", response?.data?.data?.name);
        setProjectBannerImg(response.data.data.imageUrl)
      }
    } catch (error) {
      if (error.response.data.statusCode == 401) {
        // refreshTokeen()
        const connectorId = window.localStorage.getItem("connectorId")
        await logout(connectorId);
        localStorage.removeItem("connectorId");
        localStorage.removeItem("flag");
        localStorage?.removeItem("accessToken");
        localStorage?.removeItem("sign");
        localStorage?.removeItem("userId");
        localStorage?.removeItem("refreshToken");
        localStorage?.removeItem("addrSign");;
        localStorage.removeItem('userId')
        setWallet(null)
      }
      console.error('Error occurred while creating task:', error);
    }
  }
  function connectWalletts() {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    // console.log(isMobile, 'isMobile');

    if (isMobile) {
      // On mobile, directly call handleShow
      handleShow();
      return;
    }
    // typeof window.ethereum === 'undefined'
    if (false) {
      // Show a toast error if MetaMask is not installed on desktop
      // toast.info('Please install MetaMask to connect your wallet.');
      CustomToast.show('warning', 'Warning!', 'Please install MetaMask to connect your wallet.')

    } else {
      // Proceed with the desktop-specific wallet connection logic
      handleShow();
    }
  }
  // useEffect(() => {
  //   // Initialize the socket connection when component mounts
  //   const newSocket = io(API_URL, { autoConnect: false });

  //   // Listen for `NOTIFICATION_ALERT` event
  //   newSocket.on("NOTIFICATION_ALERT", (notification) => {
  //     console.log("Notification received:", notification);
  //     setNotificationBool(!notificationBool)
  //   });

  //   // Set the socket instance in the state
  //   setSocket(newSocket);

  //   // Cleanup the socket connection on unmount
  //   return () => {
  //     newSocket.disconnect();
  //   };
  // }, []);

  // const connect = (accessToken) => {
  //   if (socket) {
  //     socket.connect();
  //     socket.on("connect", () => {
  //       console.log("Connected");
  //       setStatus("Connected");

  //       // Send authentication token after connection
  //       socket.emit("authentication", {
  //         token: accessToken,
  //       });
  //     });

  //     socket.on("disconnect", (reason) => {
  //       console.log(`Disconnected: ${reason}`);
  //       setStatus(`Disconnected: ${reason}`);
  //     });

  //     socket.open();
  //   }
  // };


  const disconnect = () => {
    // if (socket) {
    //   socket.disconnect();
    //   setStatus("Disconnected");
    // }
  };

  useEffect(() => {
    if (!currAccount) {
      setCurrAccount(account);
    } else {
      // clearData()
    }
  }, [account])

  useEffect(() => {
    let sign = localStorage.getItem("sign")
    if (account && sign) {
      getProfile()
    }

  }, [account, profile])
  // useEffect(() => {
  //   if(userData?.accessToken){
  //     connect(userData?.accessToken)
  //   }

  // }, [userData])
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 142) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);


    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isBlogRoute = pathname === "/blogdetail" || pathname.startsWith("/blogdetail/");

  return (
    <>
      {loader && <Loader />}
      <section className={`main-navbar ${isSticky ? "sticky" : ""} ${isBlogRoute ? "white-bg" : ""}`}>

        <div className="custom-container">

          <nav class="navbar navbar-expand-lg justify-content-between p-0">
            <ConditionalLink class="navbar-brand" to="/"><img src="\newlogo.svg" alt="img" className="img-fluid" /></ConditionalLink>
            <div className="navright">
              {/* <Dropdown align={'end'} className="notificationmainbtn">
                    <Dropdown.Toggle id="dropdown-basic">
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M19.0609 15.1198C18.584 14.2983 17.875 11.9737 17.875 8.9375C17.875 7.11414 17.1507 5.36545 15.8614 4.07614C14.5721 2.78683 12.8234 2.0625 11 2.0625C9.17665 2.0625 7.42797 2.78683 6.13865 4.07614C4.84934 5.36545 4.12501 7.11414 4.12501 8.9375C4.12501 11.9745 3.41517 14.2983 2.93821 15.1198C2.81642 15.3287 2.75185 15.566 2.75102 15.8078C2.75019 16.0496 2.81312 16.2873 2.93349 16.497C3.05385 16.7067 3.22738 16.8809 3.43657 17.0022C3.64576 17.1234 3.88323 17.1873 4.12501 17.1875H7.63212C7.79074 17.9636 8.21256 18.6612 8.82625 19.1622C9.43994 19.6631 10.2078 19.9367 11 19.9367C11.7922 19.9367 12.5601 19.6631 13.1738 19.1622C13.7875 18.6612 14.2093 17.9636 14.3679 17.1875H17.875C18.1167 17.1872 18.3541 17.1231 18.5632 17.0018C18.7722 16.8805 18.9456 16.7063 19.0659 16.4966C19.1862 16.2869 19.249 16.0493 19.2481 15.8076C19.2473 15.5659 19.1827 15.3286 19.0609 15.1198ZM11 18.5625C10.5736 18.5624 10.1577 18.4301 9.8096 18.1838C9.46148 17.9376 9.19824 17.5895 9.05611 17.1875H12.9439C12.8018 17.5895 12.5385 17.9376 12.1904 18.1838C11.8423 18.4301 11.4264 18.5624 11 18.5625ZM4.12501 15.8125C4.78673 14.6747 5.50001 12.0381 5.50001 8.9375C5.50001 7.47881 6.07947 6.07986 7.11092 5.04841C8.14237 4.01696 9.54132 3.4375 11 3.4375C12.4587 3.4375 13.8576 4.01696 14.8891 5.04841C15.9205 6.07986 16.5 7.47881 16.5 8.9375C16.5 12.0355 17.2116 14.6721 17.875 15.8125H4.12501Z" fill="#013159" />
                        <circle cx="18" cy="4" r="4" fill="#FE0000" />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                     <Notifications/>
                    </Dropdown.Menu>
                  </Dropdown> */}
              {account && <Notifications userData={userData} />}
              {
                wallet ?
                  <div class="dropdownmain">
                    <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <img src={projectBannerImg ? projectBannerImg : '/assets/edituploadimg.png'} alt="img" className="img-fluid" />
                      <h6>{wallet.slice(0, 5)}...{wallet.slice(-3)}</h6> <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M12 7.5L9 10.5L6 7.5" stroke="#013159" stroke-width="1.5" stroke-linecap="square" />
                      </svg>
                    </button>
                    <ul class="dropdown-menu">
                      <div className="upper-items">
                        <div className="left-side">
                          <div className="profile">
                            <img src={projectBannerImg ? projectBannerImg : '/assets/edituploadimg.png'} alt="img" className="img-fluid" />
                            <h6>{wallet.slice(0, 5)}...{wallet.slice(-3)}</h6>
                          </div>
                        </div>
                        <a onClick={() => clearData()} className="btn-disconnect">Disconnect</a>
                      </div>
                      <div className="bottom-links">
                        <ConditionalLink href="/taskparticipate" className="single-link">
                          <div className="text">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <path d="M18.0398 9.68744C18.1224 9.83069 18.1448 10.0008 18.1022 10.1606C18.0596 10.3203 17.9554 10.4567 17.8125 10.5398L10.3125 14.9148C10.2169 14.9705 10.1083 14.9999 9.99766 14.9999C9.88703 14.9999 9.77838 14.9705 9.68281 14.9148L2.18281 10.5398C2.04195 10.4551 1.94009 10.3184 1.8993 10.1592C1.8585 10 1.88205 9.83116 1.96484 9.6892C2.04764 9.54723 2.18301 9.44359 2.34166 9.40071C2.50031 9.35784 2.66946 9.37917 2.8125 9.46009L10 13.6515L17.1875 9.46009C17.3308 9.37755 17.5009 9.35512 17.6606 9.39773C17.8204 9.44034 17.9567 9.54451 18.0398 9.68744ZM1.875 6.24994C1.87525 6.14047 1.90425 6.03299 1.95909 5.93824C2.01393 5.8435 2.0927 5.76483 2.1875 5.71009L9.6875 1.33509C9.78307 1.27936 9.89171 1.25 10.0023 1.25C10.113 1.25 10.2216 1.27936 10.3172 1.33509L17.8172 5.71009C17.9115 5.76514 17.9898 5.84395 18.0442 5.93867C18.0986 6.03339 18.1272 6.14071 18.1272 6.24994C18.1272 6.35917 18.0986 6.46649 18.0442 6.56121C17.9898 6.65593 17.9115 6.73474 17.8172 6.78978L10.3172 11.1648C10.2216 11.2205 10.113 11.2499 10.0023 11.2499C9.89171 11.2499 9.78307 11.2205 9.6875 11.1648L2.1875 6.78978C2.0927 6.73505 2.01393 6.65637 1.95909 6.56163C1.90425 6.46689 1.87525 6.35941 1.875 6.24994ZM3.74063 6.24994L10 9.9015L16.2594 6.24994L10 2.59838L3.74063 6.24994ZM18.125 14.9999H16.875V13.7499C16.875 13.5842 16.8092 13.4252 16.6919 13.308C16.5747 13.1908 16.4158 13.1249 16.25 13.1249C16.0842 13.1249 15.9253 13.1908 15.8081 13.308C15.6908 13.4252 15.625 13.5842 15.625 13.7499V14.9999H14.375C14.2092 14.9999 14.0503 15.0658 13.9331 15.183C13.8158 15.3002 13.75 15.4592 13.75 15.6249C13.75 15.7907 13.8158 15.9497 13.9331 16.0669C14.0503 16.1841 14.2092 16.2499 14.375 16.2499H15.625V17.4999C15.625 17.6657 15.6908 17.8247 15.8081 17.9419C15.9253 18.0591 16.0842 18.1249 16.25 18.1249C16.4158 18.1249 16.5747 18.0591 16.6919 17.9419C16.8092 17.8247 16.875 17.6657 16.875 17.4999V16.2499H18.125C18.2908 16.2499 18.4497 16.1841 18.5669 16.0669C18.6842 15.9497 18.75 15.7907 18.75 15.6249C18.75 15.4592 18.6842 15.3002 18.5669 15.183C18.4497 15.0658 18.2908 14.9999 18.125 14.9999ZM10.9375 16.8562L10 17.4031L2.8125 13.2101C2.67019 13.1392 2.50623 13.1253 2.35399 13.171C2.20175 13.2168 2.07267 13.3189 1.99303 13.4565C1.91338 13.594 1.88916 13.7568 1.92529 13.9116C1.96142 14.0664 2.05518 14.2017 2.1875 14.2898L9.6875 18.6648C9.78307 18.7205 9.89171 18.7499 10.0023 18.7499C10.113 18.7499 10.2216 18.7205 10.3172 18.6648L11.5672 17.9359C11.6392 17.8951 11.7024 17.8405 11.7532 17.7751C11.8039 17.7097 11.8412 17.6349 11.8628 17.555C11.8844 17.4751 11.8899 17.3917 11.879 17.3096C11.8681 17.2276 11.841 17.1485 11.7993 17.077C11.7576 17.0055 11.7021 16.943 11.6361 16.8932C11.57 16.8433 11.4947 16.807 11.4146 16.7865C11.3344 16.7659 11.2509 16.7615 11.169 16.7735C11.0871 16.7854 11.0084 16.8136 10.9375 16.8562Z" fill="#013159" />
                            </svg>
                            <h6>Tasks I Participated In</h6>
                          </div>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                            <path d="M8.33325 6.75643L11.6666 10.0898L8.33325 13.4231" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </ConditionalLink>
                        <ConditionalLink href="/taskscreated" className="single-link">
                          <div className="text">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <path d="M16.25 8.75H3.75C3.41848 8.75 3.10054 8.8817 2.86612 9.11612C2.6317 9.35054 2.5 9.66848 2.5 10V11.875C2.5 12.2065 2.6317 12.5245 2.86612 12.7589C3.10054 12.9933 3.41848 13.125 3.75 13.125H16.25C16.5815 13.125 16.8995 12.9933 17.1339 12.7589C17.3683 12.5245 17.5 12.2065 17.5 11.875V10C17.5 9.66848 17.3683 9.35054 17.1339 9.11612C16.8995 8.8817 16.5815 8.75 16.25 8.75ZM16.25 11.875H3.75V10H16.25V11.875ZM16.25 3.125H3.75C3.41848 3.125 3.10054 3.2567 2.86612 3.49112C2.6317 3.72554 2.5 4.04348 2.5 4.375V6.25C2.5 6.58152 2.6317 6.89946 2.86612 7.13388C3.10054 7.3683 3.41848 7.5 3.75 7.5H16.25C16.5815 7.5 16.8995 7.3683 17.1339 7.13388C17.3683 6.89946 17.5 6.58152 17.5 6.25V4.375C17.5 4.04348 17.3683 3.72554 17.1339 3.49112C16.8995 3.2567 16.5815 3.125 16.25 3.125ZM16.25 6.25H3.75V4.375H16.25V6.25ZM12.5 16.875C12.5 17.0408 12.4342 17.1997 12.3169 17.3169C12.1997 17.4342 12.0408 17.5 11.875 17.5H10.625V18.75C10.625 18.9158 10.5592 19.0747 10.4419 19.1919C10.3247 19.3092 10.1658 19.375 10 19.375C9.83424 19.375 9.67527 19.3092 9.55806 19.1919C9.44085 19.0747 9.375 18.9158 9.375 18.75V17.5H8.125C7.95924 17.5 7.80027 17.4342 7.68306 17.3169C7.56585 17.1997 7.5 17.0408 7.5 16.875C7.5 16.7092 7.56585 16.5503 7.68306 16.4331C7.80027 16.3158 7.95924 16.25 8.125 16.25H9.375V15C9.375 14.8342 9.44085 14.6753 9.55806 14.5581C9.67527 14.4408 9.83424 14.375 10 14.375C10.1658 14.375 10.3247 14.4408 10.4419 14.5581C10.5592 14.6753 10.625 14.8342 10.625 15V16.25H11.875C12.0408 16.25 12.1997 16.3158 12.3169 16.4331C12.4342 16.5503 12.5 16.7092 12.5 16.875Z" fill="#013159" />
                            </svg>
                            <h6>Tasks I Created</h6>
                          </div>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                            <path d="M8.33325 6.75643L11.6666 10.0898L8.33325 13.4231" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </ConditionalLink>
                        <Link to="/editprofile" className="single-link">
                          <div className="text">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <path d="M17.7586 5.73214L14.268 2.24073C14.1519 2.12463 14.0141 2.03253 13.8624 1.96969C13.7107 1.90685 13.5482 1.87451 13.384 1.87451C13.2198 1.87451 13.0572 1.90685 12.9056 1.96969C12.7539 2.03253 12.6161 2.12463 12.5 2.24073L2.8664 11.8751C2.74983 11.9908 2.6574 12.1284 2.5945 12.2801C2.5316 12.4318 2.49947 12.5945 2.5 12.7587V16.2501C2.5 16.5816 2.63169 16.8996 2.86612 17.134C3.10054 17.3684 3.41848 17.5001 3.75 17.5001H7.24141C7.40562 17.5006 7.5683 17.4685 7.71999 17.4056C7.87167 17.3427 8.00935 17.2503 8.125 17.1337L17.7586 7.5001C17.8747 7.38403 17.9668 7.24622 18.0296 7.09454C18.0925 6.94286 18.1248 6.7803 18.1248 6.61612C18.1248 6.45194 18.0925 6.28937 18.0296 6.1377C17.9668 5.98602 17.8747 5.84821 17.7586 5.73214ZM7.24141 16.2501H3.75V12.7587L10.625 5.8837L14.1164 9.3751L7.24141 16.2501ZM15 8.49073L11.5086 5.0001L13.3836 3.1251L16.875 6.61573L15 8.49073Z" fill="#013159" />
                            </svg>
                            <h6>Edit Profile</h6>
                          </div>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                            <path d="M8.33325 6.75643L11.6666 10.0898L8.33325 13.4231" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </Link>
                      </div>
                    </ul>
                  </div>
                  :
                  <>

                    <a onClick={() => { clearData('noRoute'); connectWalletts() }} className="btn-connectwallet"><span className="d-noneinmobile">Connect Wallet</span> <span className="d-blockinmobile d-none">Sign In</span></a>

                  </>
              }
            </div>
          </nav>
        </div>
      </section>

      <Modal className="connectwallet-modal" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Connect wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="connectwallet-btns">
            <a className="metamaskhide-mbl " onClick={() => {
              // <a className=" " onClick={() => {
              connectMetaMask1()
            }}><img src="\assets\metamask.svg" alt="img" className="img-fluid" /> Metamask</a>
            <a onClick={() => {
              trustWallet()
            }}><img src="\assets\wallet.svg" alt="img" className="img-fluid" /> WalletConnect</a>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={show2} onHide={handleClose2} className="modal_main" centered backdrop={false} keyboard={false}>
        <Modal.Header style={{ justifyContent: "center" }}>
          <Modal.Title>Sign Required</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal1">
            <h1>Please Provide Sign to continue</h1>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="modal_footer">
            <button className="surebutton" onClick={() => { signInUser() }}>User Sign</button>
          </div>
        </Modal.Footer>
      </Modal>


      <Offcanvas className={wallet ? "mobilemenu-offcanvas " : "mobilemenu-offcanvas whentrue"} show={show1} onHide={handleClose1}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title> <img src="\newlogo.svg" alt="img" className="img-fluid" /> </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {
            wallet && <div class="off-dropdown-menu">
              <div className="upper-items">
                <div className="left-side">
                  <div className="profile">
                    <img src="\assets\dummy\profile1.png" alt="img" className="img-fluid" />
                    <h6>{wallet.slice(0, 5)}...{wallet.slice(-3)}</h6>
                  </div>
                </div>
                <a onClick={() => clearData()} className="btn-disconnect">Disconnect</a>
              </div>
              <div className="bottom-links">
                <ConditionalLink href="/taskparticipate" className="single-link">
                  <div className="text">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                      <path d="M10.3342 6.88569C10.5799 7.13138 10.5799 7.52972 10.3342 7.77541L7.81762 10.292C7.57193 10.5377 7.17359 10.5377 6.9279 10.292L5.66963 9.03368C5.42393 8.78799 5.42393 8.38965 5.66963 8.14396C5.91532 7.89826 6.31366 7.89826 6.55935 8.14396L7.37276 8.95736L9.44443 6.88569C9.69012 6.63999 10.0885 6.63999 10.3342 6.88569Z" fill="#FF0083" />
                      <path d="M10.3342 13.1774C10.5799 13.4231 10.5799 13.8215 10.3342 14.0672L7.81762 16.5838C7.57193 16.8294 7.17359 16.8294 6.9279 16.5838L5.66963 15.3255C5.42393 15.0797 5.42393 14.6814 5.66963 14.4356C5.91532 14.19 6.31366 14.19 6.55935 14.4356L7.37276 15.2491L9.44443 13.1774C9.69012 12.9318 10.0885 12.9318 10.3342 13.1774Z" fill="#FF0083" />
                      <path d="M11.7773 8.58885C11.7773 8.24139 12.0591 7.95972 12.4065 7.95972H16.1813C16.5287 7.95972 16.8104 8.24139 16.8104 8.58885C16.8104 8.93631 16.5287 9.21799 16.1813 9.21799H12.4065C12.0591 9.21799 11.7773 8.93631 11.7773 8.58885Z" fill="#FF0083" />
                      <path d="M6.11442 2.92676C4.37712 2.92676 2.96875 4.33513 2.96875 6.07243V17.3968C2.96875 19.1341 4.37712 20.5425 6.11442 20.5425H11.273C11.0692 20.1439 10.9029 19.7229 10.7789 19.2842H6.11442C5.07203 19.2842 4.22702 18.4392 4.22702 17.3968V6.07243C4.22702 5.03004 5.07203 4.18503 6.11442 4.18503H17.4388C18.4812 4.18503 19.3262 5.03004 19.3262 6.07243V10.7369C19.7649 10.8609 20.1859 11.0272 20.5845 11.231V6.07243C20.5845 4.33513 19.1761 2.92676 17.4388 2.92676H6.11442Z" fill="#FF0083" />
                      <path d="M17.5167 11.9182C16.3968 11.9182 15.3021 12.2503 14.3709 12.8725C13.4398 13.4946 12.7141 14.379 12.2855 15.4136C11.8569 16.4482 11.7448 17.5867 11.9633 18.6851C12.1818 19.7834 12.721 20.7923 13.5129 21.5842C14.3048 22.3761 15.3137 22.9154 16.4121 23.1338C17.5104 23.3523 18.6489 23.2402 19.6835 22.8116C20.7182 22.3831 21.6025 21.6573 22.2247 20.7262C22.8468 19.795 23.1789 18.7003 23.1789 17.5804C23.1789 16.0787 22.5824 14.6385 21.5205 13.5766C20.4586 12.5148 19.0184 11.9182 17.5167 11.9182ZM16.7078 19.8416L14.6856 17.8194L15.3289 17.176L16.7078 18.5548L19.7047 15.5582L20.3501 16.1996L16.7078 19.8416Z" fill="#FF0083" />
                    </svg>
                    <h6>Tasks i Participated In</h6>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M8.33325 6.75643L11.6666 10.0898L8.33325 13.4231" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </ConditionalLink>
                <ConditionalLink href="/taskcreated" className="single-link">
                  <div className="text">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                      <path d="M10.6243 7.46578C10.8586 7.70009 10.8586 8.07999 10.6243 8.3143L8.22426 10.7143C7.98995 10.9486 7.61006 10.9486 7.37574 10.7143L6.17574 9.5143C5.94142 9.27999 5.94142 8.90009 6.17574 8.66578C6.41006 8.43146 6.78995 8.43146 7.02426 8.66578L7.8 9.44151L9.77574 7.46578C10.0101 7.23146 10.39 7.23146 10.6243 7.46578Z" fill="#FF0083" />
                      <path d="M10.6243 13.4657C10.8586 13.7001 10.8586 14.08 10.6243 14.3144L8.22426 16.7144C7.98995 16.9486 7.61006 16.9486 7.37574 16.7144L6.17574 15.5144C5.94142 15.28 5.94142 14.9001 6.17574 14.6657C6.41006 14.4315 6.78995 14.4315 7.02426 14.6657L7.8 15.4415L9.77574 13.4657C10.0101 13.2315 10.39 13.2315 10.6243 13.4657Z" fill="#FF0083" />
                      <path d="M12 9.08999C12 8.75862 12.2687 8.48999 12.6 8.48999H16.2C16.5313 8.48999 16.8 8.75862 16.8 9.08999C16.8 9.42136 16.5313 9.68999 16.2 9.68999H12.6C12.2687 9.68999 12 9.42136 12 9.08999Z" fill="#FF0083" />
                      <path d="M6.6001 3.68994C4.94325 3.68994 3.6001 5.03309 3.6001 6.68994V17.4899C3.6001 19.1468 4.94325 20.4899 6.6001 20.4899H11.5198C11.3254 20.1098 11.1669 19.7083 11.0485 19.2899H6.6001C5.60598 19.2899 4.8001 18.484 4.8001 17.4899V6.68994C4.8001 5.69583 5.60598 4.88994 6.6001 4.88994H17.4001C18.3942 4.88994 19.2001 5.69583 19.2001 6.68994V11.1384C19.6184 11.2567 20.0199 11.4153 20.4001 11.6096V6.68994C20.4001 5.03309 19.0569 3.68994 17.4001 3.68994H6.6001Z" fill="#FF0083" />
                      <path d="M17.4 22.8898C20.3824 22.8898 22.8 20.4722 22.8 17.4898C22.8 14.5075 20.3824 12.0898 17.4 12.0898C14.4176 12.0898 12 14.5075 12 17.4898C12 20.4722 14.4176 22.8898 17.4 22.8898ZM17.4 14.4898C17.7313 14.4898 18 14.7585 18 15.0898V16.8898H19.8C20.1313 16.8898 20.4 17.1585 20.4 17.4898C20.4 17.8212 20.1313 18.0898 19.8 18.0898H18V19.8898C18 20.2212 17.7313 20.4898 17.4 20.4898C17.0687 20.4898 16.8 20.2212 16.8 19.8898V18.0898H15C14.6687 18.0898 14.4 17.8212 14.4 17.4898C14.4 17.1585 14.6687 16.8898 15 16.8898H16.8V15.0898C16.8 14.7585 17.0687 14.4898 17.4 14.4898Z" fill="#FF0083" />
                    </svg>
                    <h6>Tasks I Created</h6>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M8.33325 6.75643L11.6666 10.0898L8.33325 13.4231" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </ConditionalLink>
                <Link to="/editprofile" className="single-link">
                  <div className="text">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                      <path d="M12 12.0898C14.7614 12.0898 17 9.85127 17 7.08984C17 4.32842 14.7614 2.08984 12 2.08984C9.23858 2.08984 7 4.32842 7 7.08984C7 9.85127 9.23858 12.0898 12 12.0898Z" stroke="#FF0083" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M19.2101 15.8299L15.67 19.3699C15.53 19.5099 15.4 19.7699 15.37 19.9599L15.18 21.3098C15.11 21.7998 15.45 22.1399 15.94 22.0699L17.29 21.8799C17.48 21.8499 17.75 21.7199 17.88 21.5799L21.42 18.0399C22.03 17.4299 22.32 16.7199 21.42 15.8199C20.53 14.9299 19.8201 15.2199 19.2101 15.8299Z" stroke="#FF0083" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M18.7002 16.3398C19.0002 17.4198 19.8402 18.2598 20.9202 18.5598" stroke="#FF0083" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3.40991 22.0898C3.40991 18.2198 7.25994 15.0898 11.9999 15.0898C13.0399 15.0898 14.0399 15.2398 14.9699 15.5198" stroke="#FF0083" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <h6>Edit Profile</h6>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M8.33325 6.75643L11.6666 10.0898L8.33325 13.4231" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </Link>
              </div>
            </div>
          }
          {
            wallet ? <a onClick={() => clearData()} className="btn-disconnect-bottom">Disconnect</a> :
              <a onClick={() => { clearData('noRoute'); handleShow() }} className="btn-connectwallet">CONNECT WALLET</a>
          }


        </Offcanvas.Body>
      </Offcanvas>


    </>
  );
};

export default Navbar;
